export default __webpack_public_path__ + "static/media/id.3eb933da.svg";